export default __webpack_public_path__ + "static/societe-generale-c46cf6f2ece4ae85dfce11e606884bac.png";